import { create } from "zustand";

export const CONFIDENTIAL_ROUTE_ID = "confidential";

export type ConfidentialSession = {
  id: string;
  expiresAt: string;
  title: string;
};

interface ConfidentialSessionState {
  session: ConfidentialSession | null;
  status: "idle" | "active" | "expired";
  start: (session: Omit<ConfidentialSession, "title">) => void;
  setTitle: (title: string) => void;
  expire: () => void;
  clear: () => void;
}

export const useConfidentialSessionStore = create<ConfidentialSessionState>(
  (set) => ({
    session: null,
    status: "idle",
    start: (session) =>
      set({ session: { ...session, title: "" }, status: "active" }),
    setTitle: (title) =>
      set((state) => ({
        session: state.session ? { ...state.session, title } : null,
      })),
    expire: () => set({ status: "expired" }),
    clear: () => set({ session: null, status: "idle" }),
  }),
);
